import gql from "graphql-tag";



export const ERRO_ATUALIZACAO_CADASTRAL_PENDENTE = "ATUALIZACAO_CADASTRAL_PENDENTE";

export const ATUALIZACAO_CADASTRAL_PENDENTE = gql`
  query atualizacaoCadastralPendente {
    atualizacaoCadastralPendente {
      pendente
      atualizacoes
      titulo
      mensagem
      campos {
        campo
        rotulo
        valorAtual
        obrigatorio
      }
    }
  }
`;

export const SALVAR_ATUALIZACAO_CADASTRAL = gql`
  mutation salvarAtualizacaoCadastral($valores: [CampoValorInput]) {
    salvarAtualizacaoCadastral(valores: $valores) {
      sucesso
      erros {
        campo
        mensagem
      }
    }
  }
`;

export interface CampoPendente {
  campo: string;
  rotulo: string;
  valorAtual: string | null;
  obrigatorio: boolean;
}

export interface PendenciaAtualizacaoCadastral {
  pendente: boolean;
  atualizacoes: number[] | null;
  titulo: string | null;
  mensagem: string | null;
  campos: CampoPendente[] | null;
}

export interface AtualizacaoCadastralPendenteQuery {
  atualizacaoCadastralPendente: PendenciaAtualizacaoCadastral | null;
}

export interface CampoValorInput {
  campo: string;
  valor: string;
}

export interface ErroCampo {
  campo: string | null;
  mensagem: string;
}

export interface SalvarAtualizacaoCadastralMutation {
  salvarAtualizacaoCadastral: {
    sucesso: boolean;
    erros: ErroCampo[] | null;
  } | null;
}

export interface SalvarAtualizacaoCadastralMutationVariables {
  valores: CampoValorInput[];
}
